import React, { useState } from 'react';
import { FileWarning, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const download = (report, prefix) => {
  const blob = new Blob([JSON.stringify(report, null, 2)], { type: 'application/json' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `${prefix}-${new Date().toISOString().replace(/[:.]/g, '-')}.json`;
  a.click();
  URL.revokeObjectURL(a.href);
};

// Starts a read-only background report, polls by run_id with progress, downloads the JSON when done.
export const BackgroundReportButton = ({ token, endpoint, label, filePrefix, dayOptions, testId, unit = 'ημέρα' }) => {
  const [state, setState] = useState('idle');
  const [days, setDays] = useState(dayOptions[0]);
  const [progress, setProgress] = useState(null);
  const [detail, setDetail] = useState('');
  const headers = { Authorization: `Bearer ${token}` };

  const run = async (e) => {
    e.stopPropagation();
    setState('running'); setProgress(null); setDetail('');
    try {
      const start = await (await fetch(`${API}/api/diagnostic/${endpoint}?days=${days}`, { method: 'POST', headers })).json();
      if (!start.run_id) throw new Error(start.detail || 'no run id');
      for (let i = 0; i < 720; i += 1) {
        await new Promise((r) => setTimeout(r, 5000));
        let j;
        try { j = await (await fetch(`${API}/api/diagnostic/${endpoint}?run_id=${start.run_id}`, { headers })).json(); } catch { continue; }
        const rep = j.report;
        if (!rep) continue;
        if (rep.status === 'running') { setProgress(rep.progress); continue; }
        if (rep.status === 'done') download(rep, filePrefix);
        setDetail(rep.error || '');
        setState(rep.status === 'done' ? 'idle' : rep.status);
        return;
      }
      setDetail('δεν ολοκληρώθηκε σε 60 λεπτά'); setState('error');
    } catch (err) {
      setDetail(String(err.message || err)); setState('error');
    }
  };

  const text = state === 'running'
    ? `${label}… ${progress?.of ? `${unit} ${progress.done}/${progress.of}` : 'ξεκινά'}`
    : state === 'error' ? `${label}: σφάλμα` : state === 'interrupted' ? `${label}: διακόπηκε, ξαναπάτα` : label;
  return (
    <span className="flex items-center gap-1.5">
      <select value={days} onChange={(e) => setDays(Number(e.target.value))} onClick={(e) => e.stopPropagation()}
        disabled={state === 'running'}
        className="normal-case font-normal bg-transparent border border-gray-300 dark:border-gray-600 rounded px-1 text-[10px]"
        data-testid={`${testId}-days-select`}>
        {dayOptions.map((d) => <option key={d} value={d}>{d} ημ.</option>)}
      </select>
      <button type="button" onClick={run} disabled={state === 'running'} title={detail}
        className="flex items-center gap-1 normal-case font-normal text-amber-600 dark:text-amber-400 hover:underline disabled:opacity-60"
        data-testid={`${testId}-btn`}>
        {state === 'running' ? <Loader2 className="w-3 h-3 animate-spin" /> : <FileWarning className="w-3 h-3" />}
        {text}
      </button>
    </span>
  );
};
